import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    options: { type: Object, default: {} },
  };

  connect() {
    this.initializeTomSelect();
  }

  initializeTomSelect() {
    const options = {
      plugins: ['remove_button'],
      render: {
        item: (data, escape) => {
          return `<div><span>${escape(data.text)}</span></div>`;
        },
        option: (data, escape) => {
          return `<div class="py-2 px-3 transition-colors duration-150"><span>${escape(data.text)}</span></div>`;
        },
      },
      ...this.optionsValue,
    };

    this.tomSelect = new TomSelect(this.element, options);
  }

  disconnect() {
    // Clean up the Tom Select instance when the controller is disconnected
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}
